import { createIdcsSession } from "../../services/idcs-service.es.js";
import { p as parseCookies, g as getRootDomain, s as setCookieValue } from "../../../cookies-04bd2321.js";
import { logger } from "../../../utils/logger.es.js";
import { getUtmParams } from "../utils/getUtmParams.es.js";
import { formatUtmParams } from "./utils.es.js";
import "../../../utils/sharedServiceUrl.es.js";
let isGetSessionIdRunning = false;
let pendingSessionPromise = null;
const getSessionId = async () => {
  if (isGetSessionIdRunning && pendingSessionPromise) {
    return pendingSessionPromise;
  }
  const cookies = parseCookies();
  let sessionId = cookies["eh_session_id"];
  const params = new URLSearchParams(window.location.search);
  if (sessionId) {
    return sessionId;
  }
  isGetSessionIdRunning = true;
  pendingSessionPromise = (async () => {
    try {
      let formattedUtmParams = {};
      if (params) {
        const utmParams = getUtmParams(params);
        formattedUtmParams = formatUtmParams(utmParams);
      }
      const userAgent = navigator.userAgent;
      try {
        const sessionData = await createIdcsSession({ ...formattedUtmParams, userAgent });
        const newSessionId = sessionData == null ? void 0 : sessionData.id;
        if (newSessionId) {
          const rootDomain = getRootDomain(window.location.hostname);
          const cookieOptions = {
            domain: rootDomain,
            httpOnly: false,
            path: "/"
          };
          setCookieValue("eh_session_id", newSessionId, cookieOptions);
          return newSessionId;
        }
      } catch (error) {
        logger.error("Failed to create IDCS session:", error);
      }
      return null;
    } finally {
      isGetSessionIdRunning = false;
      pendingSessionPromise = null;
    }
  })();
  return pendingSessionPromise;
};
export {
  getSessionId
};
